import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { defaultNS } from "@/lib/i18n";

import Icon from "../../Icon/Icon";
import VStack from "../../Layout/VStack";

import { useGlobalErrorDialog } from "./state";

export function GlobalErrorDialog() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "component.GlobalErrorDialog",
  });
  const { isOpen, props } = useGlobalErrorDialog();

  return (
    <Dialog open={isOpen}>
      <DialogContent hideCloseButton className="max-w-72 py-9">
        <VStack className="items-center text-center gap-4">
          <Icon
            iconName="TriangleAlertIcon"
            className="text-destructive size-8 stroke-2"
          />

          <DialogTitle className="text-xl font-semibold">
            {props?.title || t("title")}
          </DialogTitle>

          <DialogDescription className="text-muted-foreground text-sm whitespace-pre-wrap">
            {props?.description || t("message")}
          </DialogDescription>

          <Button variant="outline" onClick={props?.onGoBack} size="sm">
            {t("goBackButton")}
          </Button>
        </VStack>
      </DialogContent>
    </Dialog>
  );
}
